<template>
  <div>
    <v-layout row justify-center mt-3 class="caption" v-if="!isButton">
      or &nbsp;
      <a @click="dialog = true">{{
        $vuetify.t('$vuetify.calls.abortVisit')
      }}</a>
    </v-layout>
    <v-btn @click="dialog = true" color="warning" v-if="isButton">{{
      $vuetify.t('$vuetify.calls.abortVisit')
    }}</v-btn>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.t('$vuetify.calls.abortVisitConfirmation')
        }}</v-card-title>

        <v-card-text>
          {{ $vuetify.t('$vuetify.calls.abortVisitConfirmationText') }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat @click="dialog = false">
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>

          <v-btn color="green darken-1" flat @click="abortVisit()">
            {{ $vuetify.t('$vuetify.calls.yesAbortVisit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['isButton'],
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    abortVisit() {
      this.$emit('aborted')
    }
  }
}
</script>
